import { Link, useLocation } from 'react-router-dom';
import { tryOpenAppThenStore, APP_STORE_URL, PLAY_STORE_URL } from '../../utils/appStoreLinks';
import './UserSidebar.css';

const navItems = [
  { to: (userId) => `/users/${userId}`, label: 'Min profil', icon: 'fa-user', exact: true },
  { to: () => '/programs', label: 'Programmer', icon: 'fa-list-alt' },
  { to: () => '/activities', label: 'Aktiviteter', icon: 'fa-running' },
  { to: () => '/albums', label: 'Album', icon: 'fa-compact-disc' },
];

export default function UserSidebar({ userId, onLogout }) {
  const location = useLocation();

  const isActive = (item) => {
    const path = typeof item.to === 'function' ? item.to(userId) : item.to;
    if (item.exact) {
      return location.pathname === path;
    }
    return location.pathname === path || location.pathname.startsWith(`${path}/`);
  };

  return (
    <aside className="user-sidebar">
      <div className="user-sidebar-brand">
        <Link to="/">Lopeglad</Link>
      </div>

      <nav className="user-sidebar-nav" aria-label="Brukernavigasjon">
        {navItems.map((item) => {
          const path = item.to(userId);
          return (
            <Link
              key={path}
              to={path}
              className={`user-sidebar-link ${isActive(item) ? 'is-active' : ''}`}
            >
              <i className={`fas ${item.icon}`} aria-hidden="true" />
              {item.label}
            </Link>
          );
        })}

        <button
          type="button"
          className="user-sidebar-link user-sidebar-link--action"
          onClick={() => tryOpenAppThenStore('lopeglad://')}
        >
          <i className="fas fa-mobile-alt" aria-hidden="true" />
          Åpne i appen
        </button>
      </nav>

      <div className="user-sidebar-footer">
        <p className="user-sidebar-store-hint">
          Last ned appen:{' '}
          <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">iOS</a>
          {' · '}
          <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer">Android</a>
        </p>
        {onLogout && (
          <button type="button" className="user-sidebar-logout" onClick={onLogout}>
            <i className="fas fa-sign-out-alt" aria-hidden="true" />
            Logg ut
          </button>
        )}
      </div>
    </aside>
  );
}
